import { useEffect } from 'react';
import { MapViewport } from 'components/MapPage/MapViewport';
import { MapExitButtonGroup } from 'components/MapPage/MapSidebarComponents';
import { useUscgMapContext } from './CorporateViewTabs/LayersTab/UscgMapContext';

export function UscgMapContainer() {
  const { mapView, mapViewElementRef, setIsMapVisible } = useUscgMapContext();

  useEffect(() => {
    if (!mapView || !mapViewElementRef.current) return;

    const bench = document.getElementById('map-bench') as HTMLDivElement | null;
    const viewportContainer = mapViewElementRef.current;
    mapView.set('container', viewportContainer);
    setIsMapVisible(true);

    return () => {
      if (mapView && bench) {
        mapView.set('container', bench);
        setIsMapVisible(false);
      }
    };
  }, [mapView, mapViewElementRef, setIsMapVisible]);

  return (
    <div
      className="position-relative flex-grow-1 d-flex h-100"
      style={{ minHeight: 0 }}
    >
      <MapViewport mapViewElementRef={mapViewElementRef} isFullHeight />
      <div
        className="position-absolute d-flex gap-1"
        style={{ top: 20, right: 15 }}
      >
        <MapExitButtonGroup />
      </div>
    </div>
  );
}
